import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p>
        At <strong>Radical Sports India</strong>, we are committed to safeguarding your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you interact with our website, registration forms, or participate in our programs.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect the following personal information:
      </p>
      <ul>
        <li>Full name, age, contact details (email, phone number, address).</li>
        <li>Skater details such as gender, date of birth, and school name.</li>
        <li>Emergency contact and parent/guardian information.</li>
        <li>Photos and videos captured during training sessions or events.</li>
        <li>Feedback, inquiries, and customer service interactions.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        Your information is used to:
      </p>
      <ul>
        <li>Register students and manage training batches.</li>
        <li>Communicate updates, changes, and important announcements.</li>
        <li>Promote academy events, skater achievements, and competitions (with consent).</li>
        <li>Enhance the quality and safety of our operations.</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <p>
        Radical Sports India does <strong>not</strong> sell or rent your personal data. We may share your information:
      </p>
      <ul>
        <li>With coaches and authorized staff for training and management purposes.</li>
        <li>With sports federations or event organizers for competition participation.</li>
        <li>When legally required to comply with laws or government regulations.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement industry-standard practices to protect your personal information against unauthorized access, disclosure, or misuse. Access is restricted to authorized personnel only.
      </p>

      <h2>5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access, updates, or deletion of your personal data.</li>
        <li>Withdraw consent for the use of photos or videos.</li>
        <li>Seek clarification on how your data is used or processed.</li>
      </ul>

      <h2>6. Photos & Media</h2>
      <p>
        Photos and videos may be captured during training or events for educational or promotional use. If you wish to opt out, please notify us in writing.
      </p>

      <h2>7. Cookies (if applicable)</h2>
      <p>
        Our website may use cookies to enhance functionality and track anonymous usage data. You can manage your cookie preferences through your browser settings.
      </p>

      <h2>8. Policy Updates</h2>
      <p>
        This policy may be updated periodically. Please review this page regularly to stay informed of any changes.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        For any privacy-related concerns, contact us at:
      </p>
      <ul>
        <li><strong>Email:</strong> Info@radicalsportsindia.com</li>
        <li><strong>Phone:</strong> +91 76546 4545</li>
        <li><strong>Address:</strong> Radical Sports Academy, 2nd Floor, Ajanta Shopping Centre, 225, Daftary Road, opp. Surbhi Sweets, near Railway Station, Malad East, Mumbai, Maharashtra 400097</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
